import { createSlice } from "@reduxjs/toolkit";
import { getCardsReports } from "./reportAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  result: {},
  latestRequestId: null,
};

const reportSlice = createSlice({
  name: "cardReports",
  initialState,
  reducers: {
    manageLoadingState: (state, action) => {
      state.loading = action?.payload?.loading;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCardsReports.pending, (state, action) => {
        state.loading = true;
        state.result = {};
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getCardsReports.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.result = action.payload;
        state.error = null;
      })
      .addCase(getCardsReports.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { manageLoadingState } = reportSlice.actions;
export default reportSlice.reducer;
